import React from "react";
import rewievs1 from "../images/rewiev/1.png";
import rewievs1webp from "../images/rewiev/1.webp";
import rewievs1avif from "../images/rewiev/1.avif";
import rewievs2 from "../images/rewiev/2.png";
import rewievs2webp from "../images/rewiev/2.webp";
import rewievs2avif from "../images/rewiev/2.avif";
import rewievs3 from "../images/rewiev/3.png";
import rewievs3webp from "../images/rewiev/3.webp";
import rewievs3avif from "../images/rewiev/3.avif";
import rewievs4 from "../images/rewiev/4.png";
import rewievs4webp from "../images/rewiev/4.webp";
import rewievs4avif from "../images/rewiev/4.avif";
import rewievs5 from "../images/rewiev/5.png";
import rewievs5webp from "../images/rewiev/5.webp";
import rewievs5avif from "../images/rewiev/5.avif";
import rewievs6 from "../images/rewiev/6.png";
import rewievs6webp from "../images/rewiev/6.webp";
import rewievs6avif from "../images/rewiev/6.avif";
import rewievs7 from "../images/rewiev/7.png";
import rewievs7webp from "../images/rewiev/7.webp";
import rewievs7avif from "../images/rewiev/7.avif";
import rewievs8 from "../images/rewiev/8.png";
import rewievs8webp from "../images/rewiev/8.webp";
import rewievs8avif from "../images/rewiev/8.avif";
import rewievs9 from "../images/rewiev/9.png";
import rewievs9webp from "../images/rewiev/9.webp";
import rewievs9avif from "../images/rewiev/9.avif";
import rewievs10 from "../images/rewiev/10.png";
import rewievs10webp from "../images/rewiev/10.webp";
import rewievs10avif from "../images/rewiev/10.avif";
export const RewievsContext = React.createContext();

export const rewievs = [
  {
    key: 1,
    src: `${rewievs1}`,
    webp: `${rewievs1webp}`,
    avif: `${rewievs1avif}`,
    name: "Дина Шибаева",
    text: "С благодарностью и пожеланием творческих успехов!!! Второй год дочка с удовольствием посещает студию танца «Переворот». Всегда с радостью бежит на занятия. Внимательные, творческие и инициативные педагоги, яркие и красочные постановки и всегда положительные эмоции у детей и родителей!",
    star: 5,
    date: "20.09.2022",
    link: "https://vk.com/id63606575",
  },
  {
    key: 2,
    src: `${rewievs2}`,
    webp: `${rewievs2webp}`,
    avif: `${rewievs2avif}`,
    name: "Наталья Кузьмина",
    text: 'Всем здравствуйте! Хотела написать несколько благодарственных слов нашему педагогу по танцам Ольге Ивановне и всему коллективу школы танцев "Переворот". Три года дочь с удовольствием ходит на занятия к Ольге Ивановне. Ей нравится танцевать, участвовать в концертах и конкурсах. Сдружились они с девочками в группе, а Ольга Ивановна у неё любимый педагог) Сейчас начался учебный год и нагрузка в школе возросла, но дочь планирует ходить на танцы и дальше. Я этому рада. Школа - это стресс, а при стрессах особенно важна работа с телом. Т.к. через активность тела легче проживать непростые состояния. Плюс эстетика движения и музыки. Тренированное тело тоже важно, особенно в подростковом возрасте. Часто подростки становятся неуклюжими, т.к. им непросто бывает скоординировать своё быстро растущее тело. А танцы прекрасно помогают ребёнку лучше владеть своим телом и расти красивым). Так что, для ребёнка сплошные плюсы от посещения занятий. И особенное спасибо за отчётные концерты! С каждым годом эти мероприятия становятся всё лучше и лучше и вызывают массу положительных эмоций и у нас, родителей, сидящих в зрительном зале, и у наших детей, кто выступает на сцене. Спасибо Вам, Ольга Ивановна, и всему коллективу "Переворота"! Творческих успехов!!!',
    star: 5,
    date: "11.09.2022",
    link: "https://vk.com/natalya_kuzmina777",
  },
  {
    key: 3,
    src: `${rewievs3}`,
    webp: `${rewievs3webp}`,
    avif: `${rewievs3avif}`,
    name: "Кирилл Симаков",
    text: "Мы посещаем театр танца Переворот уже 4 года. Белла с большим удовольствие занимается танцами. Наш хореограф Ольга Ивановна- профессионал своего дела! Она внимательная, добрая. Умеет найти подход к детишкам любого возраста. К ней на занятия мы бежим с большим удовольствием. Заметны результаты труда. Это пластика, растяжка и постановки танцев. На выступлениях на конкурсах занимаем призовые места!!! Спасибо Ольге Ивановне! Мы очень рады, что занимаемся в театре танцев Переворот!",
    star: 5,
    date: "11.09.2022",
    link: "https://vk.com/bananoviyflex",
  },
  {
    key: 4,
    src: `${rewievs4}`,
    webp: `${rewievs4webp}`,
    avif: `${rewievs4avif}`,
    name: "Екатерина Агафонова",
    text: 'Дочь посещает студию танцев третий год. На занятия бежит с удовольствием. Обожает тренера Анастасию Александровну и своих девочек, с которыми сдружилась очень за время занятий) Дочка пластичная, отлично двигается, я считаю огромный опыт, что дети выступают на большой сцене с такого раннего возраста. Спасибо огромное всему тренерскому составу и руководителю. Мы будем и дальше продолжать заниматься в театре танца "Переворот"',
    star: 5,
    date: "09.09.2022",
    link: "https://vk.com/katerina650",
  },
  {
    key: 5,
    src: `${rewievs5}`,
    webp: `${rewievs5webp}`,
    avif: `${rewievs5avif}`,
    name: "Ксюша Тагирова",
    text: "Хочу оставить ещё один отзыв) сейчас ходит на танцы и младшая дочка (3х лет). Очень нравится. Наш тренер Ольга Ивановна отлично тренерует и младших и старших детей! У малышей хороши е занятия, они учатся слушать ритм, работают над своим телом ю, растяжкой! То что нужно именно малышам. Мы рады и дочка с радостью бежит на танцы к Ольге Ивановне и уже ждёт когда будут концерты и медали!",
    star: 5,
    date: "05.09.2022",
    link: "https://vk.com/id29823667",
  },
  {
    key: 6,
    src: `${rewievs6}`,
    webp: `${rewievs6webp}`,
    avif: `${rewievs6avif}`,
    name: "Алина Имамеева",
    text: "Пришли в этот театр танца по рекомендации знакомых и ни разу не пожалели . Дочка очень любит танцевать, кривляться перед зеркалом, поэтому решили отдать её на танцы. С первого занятия дочь полюбила нашего хореографа Ольгу Ивановну, с удовольствием начала ходить. Сейчас с нетерпением ждёт нового учёного года. Мы начали ходить с февраля этого года, но результаты уже есть 👍 отдельное спасибо за отчётный концерт, возможность выступать нм большой сцене- это огромнейший опыт для детей",
    star: 5,
    date: "04.09.2022",
    link: "https://vk.com/id5581797",
  },
  {
    key: 7,
    src: `${rewievs7}`,
    webp: `${rewievs7webp}`,
    avif: `${rewievs7avif}`,
    name: "Танечка Егорова",
    text: 'Спасибо огромное, театра танца "Переворот".❤ За возможность нашей дочки выступать на сцене. Это огромный труд для детей. Я хотела, чтоб моя дочка была пластичнее. Здесь обучают и не мучают детей. Мы прошли только малую группу. И не думая перешли на след.учебный год. Дочка соскучилась по танцам.😊 Наш хореограф Анастасия Александровна.🥰',
    star: 5,
    date: "03.09.2022",
    link: "https://vk.com/tatianavelikaia",
  },
  {
    key: 8,
    src: `${rewievs8}`,
    webp: `${rewievs8webp}`,
    avif: `${rewievs8avif}`,
    name: "Лейля Гатауллина",
    text: "Так как наш ребёнок любит танцевать с детства, мы не раздумывая решили отдать его на танцы. Рассматривали разные варианты танцевальных кружков, читали отзывы родителей, и по замечательным отзывам пришли в театр танца ,,Переворот,, и не ошиблись. Здесь сама атмосфера располагает к танцам, дети всегда рады посещать занятия, искренне улыбаются и с удовольствием бегут в зал, чтобы встретиться со своими друзьями и любимым хореографом Ольгой Ивановной. Все это оставляет в душе ребят и их родителей приятные впечатления.После отчётных концертов дочка ещё долго танцует танец дома, с нетерпеньем ждёт каждое занятие. Да и от нашего дома в шаговой доступности, что немаловажно для большого города. Мы очень рады,что отдали дочь именно в театр танца ,, Переворот,, и надеемся, что и впредь будем заниматься танцами только здесь.",
    star: 5,
    date: "02.09.2022",
    link: "https://vk.com/oreiroleila",
  },
  {
    key: 9,
    src: `${rewievs9}`,
    webp: `${rewievs9webp}`,
    avif: `${rewievs9avif}`,
    name: "Диляра Зинатуллина",
    text: 'Хочу поделиться своими впечатлениями о театре танца "Переворот" 😊. Старшая дочь начала заниматься танцами в 3 года и выросла можно сказать на занятиях, наш первый хореограф Юлия Фёдоровна быстро нашла подход к ребёнку, на занятия бежали с удовольствием всегда, видно что работа с детьми ведётся всесторонне, не только танцы, растяжка и т. д., но и нравственное воспитание, умение себя держать на сцене, во время выступления, дисциплина, командный дух, умение работать в команде!!! После уже подросла младшая дочь и мы отдали её тоже на танцы, наш хореограф Анастасия Александровна своим обоянием и подходом влюбила ребёнка в танцы с первого занятия! Очень радуют отчётные концерты два раза в год и хочу отдельно отметить, нет головной боли и огромных расходов на костюмы для выступлений, всё продумано до мелочей, сдаётся небольшая сумма на год и перед выступлением выдаются каждому костюмы по тематике номера, причёски тоже тщательно подбираются, так что хочу сказать огромное спасибо основательнице театра танцев Юлие Фёдоровне и нашему прекрасному хореографу Анастасии Александровне, за их вклад в развитие наших детей, за прекрасную организацию процесса от А до Я, за профессионализм, индивидуальный подход, за отзывчивость и открытость к нам родителям, для Вас нет никаких проблем, всё решаете быстро и чётко, видно что живете своим делом и большие профи в области танцев!!! Однозначно рекомендую всем данную школу танцев, здесь Ваш ребёнок вырастит всесторонне! Ещё раз большое спасибо за всё! 💕🙏🙏🙏',
    star: 5,
    date: "02.09.2022",
    link: "https://vk.com/id162936249",
  },
  {
    key: 10,
    src: `${rewievs10}`,
    webp: `${rewievs10webp}`,
    avif: `${rewievs10avif}`,
    name: "Aigulya Safina",
    text: "Начали ходить в январе этого года. Результат потрясающий! Ребенок ходит с удовольствием. До этого были в других студиях танца, ребенку было скучно и не было видно вовлеченности преподавателя. Студия Переворот вы супер! Спасибо 🔥🔥🔥",
    star: 5,
    date: "02.09.2022",
    link: "https://vk.com/aigulya_safina",
  },
];
